import { TreatmentMedicineOpenDateModel } from '@/entities/diagnosis';
import { GetDoctorTreatmentMedicineOpenDateQuery } from '@/types/bff/gql-schema';
import { useGetDoctorTreatmentMedicineOpenDateQuery } from './diagnosis.gql.impl';

const parseTreatmentMedicineOpenDate = (
  data: GetDoctorTreatmentMedicineOpenDateQuery
): TreatmentMedicineOpenDateModel | null => {
  if (!data?.getDoctorTreatmentMedicineOpenDate?.date) {
    return null;
  }

  return new TreatmentMedicineOpenDateModel({ openDate: data?.getDoctorTreatmentMedicineOpenDate?.date });
};

interface Props {
  doctorId: string;
  treatmentMedicineId?: string;
  enabled: boolean;
}

const useGetDoctorTreatmentMedicineOpenDate = (props: Props) => {
  const { data: openDate, isFetched: isOpenDateFetched } = useGetDoctorTreatmentMedicineOpenDateQuery(
    { doctorId: props.doctorId, treatmentMedicineId: props.treatmentMedicineId ?? '' },
    {
      select: parseTreatmentMedicineOpenDate,
      enabled: props.enabled,
    }
  );

  return {
    openDate,
    isOpenDateFetched,
  };
};

export default useGetDoctorTreatmentMedicineOpenDate;
